import React from 'react';
import { EmbedArcade } from 'libs/growth-platform-brand-system-v2/src/components/EmbedArcade';
import { Script } from 'gatsby';

export const EmbedArcadeComponent = ({ block }: any) => {
  return (
    <>
      <EmbedArcade src={block.src} />
      <Script>
        {`
        window.addEventListener(
          'message',
          function(event) {
            if (event.origin === 'https://demo.arcade.software') {
            var evt = event.data;
            if(evt["eventName"] !== undefined){
            dataLayer.push({
            event : evt["eventName"]})}
          }
          },
          false
        );
      `}
      </Script>
    </>
  );
};

export default EmbedArcadeComponent;
